<template>
    <registration-card
        v-if="isAuthenticated === false"
        @login="checkUserEnrollmentStatus"
        @signup="$emit('signup', $event)"
        :period="period"
    ></registration-card>

    <join-card
        v-else-if="isAuthenticated === true"
        @join="$emit('join')"
        @logout="isAuthenticated = false"
        :period="period"
    ></join-card>

    <div
        v-else
        class="d-flex justify-center"
    >
        <v-progress-circular
            indeterminate
            color="primary"
            size="48"
        ></v-progress-circular>
    </div>
</template>

<script>
import hasLocalToken from '@/tools/hasLocalToken'
import JoinCard from './JoinCard'
import RegistrationCard from './RegistrationCard'

export default {
    components: {
        JoinCard,
        RegistrationCard,
    },

    props: {
        period: {
            type: Object
        }
    },

    data: () => ({
        isAuthenticated: null,
    }),

    methods: {
        async checkUserEnrollmentStatus() {
            const response = await this.$api.get('enrollment')

            if (response.data.enrollments.find(e => e.id == this.period.id)) {
                // User already registered
                this.$store.set('enrollment/enrollments', response.data.enrollments)
                this.$store.dispatch('enrollment/selectByPeriodId', this.period.id)
                localStorage.setItem('lastSelectedPeriodId', this.period.id)

                if (! this.$store.get('enrollment/isSelectedActive')) {
                    this.$router.replace({ name: 'payment'})
                } else {
                    this.$router.replace({ name: 'dashboard' })
                }
            } else {
                this.isAuthenticated = true
            }
        }
    },

    async created() {
        if (hasLocalToken()) {
            const response = await this.$api.get('auth')

            this.$store.dispatch('auth/setDataFromAuth', response.data)

            await this.checkUserEnrollmentStatus()
        } else {
            this.isAuthenticated = false
        }
    }
}
</script>
